import { Link, Stack, useTheme } from "@mui/material";
import { IngredientSupplierActivityData } from "src/api/client-api/ingredients/useGetOneIngredient";
import { SalesBox } from "./Box/SalesBox";

type IngredientSupplierActivityDataRowProps = {
    activityData: IngredientSupplierActivityData;
};
export const IngredientSupplierActivityDataRow = (props: IngredientSupplierActivityDataRowProps) => {
    const { activityData } = props;
    const theme = useTheme();

    const quantity = activityData?.quantity;
    const grossSales = activityData?.grossSales;
    const averagePrice = !quantity || quantity <= 0 ? 0 : (grossSales ?? 0) / quantity;

    return (
        <Stack direction="row" sx={{ padding: theme.spacing(2) }}>
            <Stack flex={2}>
                <Link
                    sx={{ color: `${theme.palette.primary[700]}`, textDecoration: "none", fontWeight: "normal" }}
                    variant="h5"
                >
                    {activityData.organization.name}
                </Link>
            </Stack>
            <Stack flex={2}>
                <SalesBox value={quantity} unit={"T."} />
            </Stack>
            <Stack flex={2}>
                <SalesBox value={grossSales} unit={"€"} />
            </Stack>
            <Stack flex={2}>
                <SalesBox value={averagePrice} unit={"€/T."} />
            </Stack>
            <Stack flex={1}></Stack>
        </Stack>
    );
};
